import { AutogenLayoutCommissionsRatesList } from "./autogen/AutogenLayoutCommissionsRatesList";

export class CommissionsRatesList extends AutogenLayoutCommissionsRatesList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "id", sort: "asc" }];
    }
}
